export let state = {
    subscribedVehicle: null,
    mediaDialog: null,
    eventDialog: null
};
